import Vue from 'vue';

import {
  CLIENT_SET,
  CLIENT_USER_PAYMENT_SET,
  CLIENT_USER_UPDATED_PAYMENT_SET,
  CLIENT_USER_CHARGE_SET,
} from '../mutations-types'

const state = {
  client: null,
  userPayment: null,
  userCharge: null,
};

const getters = {
  client: state => state.client,
  userPayment: state => state.userPayment,
  userUpdatedPayment: state => state.userUpdatedPayment,
  userCharge: state => state.userCharge
};

const mutations = {
  [CLIENT_SET](state, data) {
    Vue.set(state, 'client', data);
  },

  [CLIENT_USER_PAYMENT_SET](state, data) {
    Vue.set(state, 'userPayment', data);
  },
  [CLIENT_USER_UPDATED_PAYMENT_SET](state, data) {
    Vue.set(state, 'userUpdatedPayment', data);
  },

  [CLIENT_USER_CHARGE_SET](state, data) {
    Vue.set(state, 'userCharge', data);
  },
};


const actions = {

  /**
   * @URLParams
   * affiliateCode: integer, required
   * @BodyParams
   * none
   * **/
  CLIENT_REQUEST_GET ({commit}, affiliateCode) {
    return new Promise((resolve, reject) => {
      Vue.axios.get('web/client/' + affiliateCode + '/validate').then(response=>{
        commit(CLIENT_SET, response.data)
        resolve();
      }).catch( error => {
        reject(error.response.data && error.response.data.message ? error.response.data.message: error.response.data ? error.response.data: error.response)
      });
    })
  },

  /**
   * @URLParams
   * clientId: integer, required
   * @BodyParams
   * firstName: string, required
   * lastName: string, required
   * phone: string, required
   * email: string, required
   * referrerAffiliateCode: string, required
   * referrerDomain: string, required
   * pin: string, required
   * purchasePrice: float, required
   * purchaseDate: string
   * analysisFee: float
   * **/
  CLIENT_USER_PAYMENT_REQUEST_SET ({commit}, data) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('web/client/' + data.clientId + '/user', data.payload).then(response=>{
        commit(CLIENT_USER_PAYMENT_SET, response.data)
        resolve();
      }).catch( error => {
        reject(error.response.data && error.response.data.message ? error.response.data.message: error.response.data ? error.response.data: error.response)
      });
    })
  },


  /**
   * @URLParams
   * clientId: integer, required
   * @BodyParams
   * webUserId: integer
   * analyzedPropertyId: integer
   * overpaymentAmount: float
   * **/
  CLIENT_USER_PAYMENT_REQUEST_UPDATE ({commit}, data) {
    return new Promise((resolve, reject) => {
      Vue.axios.put('web/client/' + data.clientId + '/user', data.payload).then(response => {
        commit(CLIENT_USER_UPDATED_PAYMENT_SET, response.data)
        resolve();
      }).catch(error => {
        reject(error.response.data && error.response.data.message ? error.response.data.message : error.response.data ? error.response.data : error.response)
      });
    })
  },

  /**
   * @URLParams
   * clientId: integer, required
   * userId: integer, required
   * @BodyParams
   * payeeFirstName: string, required
   * payeeLastName: string, required
   * expirationMonth: integer, required
   * expirationYear: integer, required
   * amountBilled: float, required
   * paymentProviderToken: string, required
   * cartId: integer, required
   * zipCode: integer, required
   * **/
  CLIENT_USER_CHARGE_REQUEST_SET ({commit}, data) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('web/client/' + data.clientId + '/user/' + data.userId + '/charge', data.payload).then(response=>{
        commit(CLIENT_USER_CHARGE_SET, response.data)
        resolve();
      }).catch( error => {
        reject(error.response.data && error.response.data.message ? error.response.data.message: error.response.data ? error.response.data: error.response)
      });
    })
  },
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};